



























import {Vue, Component, Prop} from "vue-property-decorator";

import {Form} from "../../../api/models/Form";
import {declOfNums} from "../../../service/helpers/languageHelper";
import SearchInput from "../../common/search-input/SearchInput.vue";

@Component({
    name: "FormSelector",
    components: { SearchInput }
})
export default class FormSelector extends Vue {
    @Prop({required: true, default: null}) forms: Form[] | null;

    searchStr = '';

    mounted() {
        setTimeout(() => {
            document.body.addEventListener('click', this.close);
        }, 50)
    }

    plural(number: number, titles: string[]): string {
        return declOfNums(number, titles);
    }

    formClick(form: Form) {
        this.$emit('selected', form)
    }

    close() {
        document.body.removeEventListener('click', this.close);
        this.$emit('close');
    }

    onInputClick(e: PointerEvent) {
        e.stopPropagation();
    }

    clearInput() {
        this.searchStr = "";
    }

    get filteredForms() {
        return this.forms?.filter(
            (form) => (form.title || this.$t('comments.defaultPollName').toString())
                .toLowerCase()
                .indexOf(this.searchStr.toLowerCase()) != -1,
        ) || []
    }
}
